import React, { useEffect, useMemo, useState } from 'react';
import { Close, Create, DoneAll, Remove } from '@material-ui/icons';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';
import RegularButton from 'components/CustomButtons/Button';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TextField from '@material-ui/core/TextField';
import TableRow from '@material-ui/core/TableRow';
import { WithApp } from 'contexts/appContext';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import { wsGetAll } from 'services/WService';
import { currency } from 'hooks/Pipe';

import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';

const useStyles = makeStyles(() => stylesAlert);

const columns = [
  { field: 'Dscription', type: 'text', align: 'left', width: 300, header: 'Concepto' },
  { field: 'AcctCode', type: 'number', align: 'left', width: 120, header: 'Cuenta' },
  { field: 'Price', type: 'number', align: 'left', width: 120, header: 'Precio' },
  { field: 'DiscPrcnt', type: 'number', align: 'left', width: 120, header: 'Descuento' },
  { field: 'PriceBefDi', type: 'number', align: 'left', width: 120, header: 'Precio.Descuento' },
  { field: 'VatGroup', type: 'text', align: 'left', width: 120, header: 'Impuesto' },
  { field: 'VatPrcnt', type: 'text', align: 'left', width: 120, header: '%Impuesto' },
  { field: 'PriceAfVAT', type: 'number', align: 'left', width: 120, header: 'Total' },
  { field: 'actions', type: 'custom', align: 'center', width: 130, header: 'Acciones' },
];

const defaultConcept = {
  Dscription: '',
  Price: 0,
  DiscPrcnt: 0,
  VatGroup: 'IGV',
  AcctCode: '',
};

function ConceptRow(props) {
  const { concept, setConcepts, taxes, accounts, index } = props;

  const { PriceBefDi, VatPrcnt, PriceAfVAT } = useMemo(() => {
    return {
      PriceBefDi: currency(concept.Price * (1 - concept.DiscPrcnt / 100)),
      VatPrcnt: parseFloat(taxes.find((tax) => tax.Code === concept.VatGroup)?.Rate || 0).toFixed(
        2,
      ),
      PriceAfVAT: currency(
        concept.Price *
          (1 - concept.DiscPrcnt / 100) *
          (1 + parseFloat(taxes.find((tax) => tax.Code === concept.VatGroup)?.Rate || 0) / 100),
      ),
    };
  }, [concept]);

  function deleteConcept() {
    setConcepts((concepts) => {
      let newConcepts = [...concepts];
      let index = newConcepts.findIndex((item) => item.id === concept.id);
      newConcepts.splice(index, 1);
      return newConcepts;
    });
  }

  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{concept.Dscription}</TableCell>
      <TableCell>{accounts.find((acct) => acct.AcctCode === concept.AcctCode)?.AcctName}</TableCell>
      <TableCell>{concept.Price}</TableCell>
      <TableCell>{concept.DiscPrcnt}</TableCell>
      <TableCell>{PriceBefDi}</TableCell>
      <TableCell>{concept.VatGroup}</TableCell>
      <TableCell>{VatPrcnt}</TableCell>
      <TableCell>{PriceAfVAT}</TableCell>
      <TableCell align="center">
        <RegularButton justIcon round size="sm" color="danger" onClick={deleteConcept}>
          <Remove />
        </RegularButton>
      </TableCell>
    </TableRow>
  );
}

function NewSaleConceptDetails(props) {
  const { classes, processing, process, saveConceptSale, dataSale } = props;
  const { updateOrder, approveOrCancel, setAlertAprobed } = props;
  const alertClasses = useStyles();

  const [taxes, setTaxes] = useState([]);
  const [conceptSelected, setConceptSelected] = useState(defaultConcept);
  const [concepts, setConcepts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [id, setId] = useState(1);

  const hideAlert = () => {
    setAlertAprobed(null);
  };

  function confirmChange(text, status) {
    setAlertAprobed(
      <SweetAlert
        warning={status}
        input={status === false ? true : false}
        style={{ display: 'block', marginTop: '-100px' }}
        title={'¿Esta seguro de ' + text + ' ?'}
        onConfirm={async (e) => {
          let res = null;
          if (status) {
            res = approveOrCancel(status);
          } else {
            res = approveOrCancel(status, { ObservacionError: e });
          }
          hideAlert();
          res = await res;
          if(res.success){
            setConcepts([]);
          }
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={alertClasses.button + ' ' + alertClasses.success}
        cancelBtnCssClass={alertClasses.button + ' ' + alertClasses.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {status ? ' ¡Esta acción tiene consecuencias!' : 'Ingrese el motivo por favor :)'}
      </SweetAlert>,
    );
  }

  async function getTaxes() {
    let res = await wsGetAll('base/tax');
    if (res.success) {
      setTaxes(res.data);
    }
  }

  async function getAccounts() {
    let res = await wsGetAll('sale/concept-accounts');
    if (res.success) {
      setAccounts(res.data);
    }
  }

  function addConcept() {
    setConcepts((concetps) => {
      let newConcetps = [...concetps];
      let VatPrcnt = taxes.find((tax) => tax.Code === conceptSelected.VatGroup).Rate;
      newConcetps.push({ ...conceptSelected, id, VatPrcnt });
      return newConcetps;
    });

    setId((id) => id + 1);
    setConceptSelected(defaultConcept);
  }

  useEffect(() => {
    getTaxes();
    getAccounts();
  }, []);

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell width="50">#</TableCell>
              {columns.map((item, i) => {
                return (
                  <TableCell key={i} width={item.width} align={item.align}>
                    {item.header}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {!process && !processing && (
              <TableRow className={classes.subHeader}>
                {/* # */}
                <TableCell></TableCell>
                {/* Dscription */}
                <TableCell>
                  <TextField
                    value={conceptSelected.Dscription}
                    fullWidth
                    onChange={(e) => {
                      let value = e.target.value;
                      setConceptSelected((concept) => ({ ...concept, Dscription: value }));
                    }}
                  />
                </TableCell>
                {/* AcctCode */}
                <TableCell>
                  <FormControl fullWidth margin="normal" size="small">
                    <Select
                      fullWidth
                      value={conceptSelected.AcctCode}
                      onChange={(e) => {
                        let value = e.target.value;
                        setConceptSelected((concept) => ({ ...concept, AcctCode: value }));
                      }}
                    >
                      {accounts.map((account) => {
                        return (
                          <MenuItem key={account.AcctCode} value={account.AcctCode}>
                            {account.AcctName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </TableCell>
                {/* Price */}
                <TableCell>
                  <TextField
                    value={conceptSelected.Price}
                    type="number"
                    fullWidth
                    onChange={(e) => {
                      let value = e.target.value;
                      setConceptSelected((concept) => ({ ...concept, Price: value }));
                    }}
                    inputProps={{
                      min: 0,
                      step: 0.01,
                    }}
                  />
                </TableCell>
                {/* DiscPrcnt */}
                <TableCell>
                  <TextField
                    value={conceptSelected.DiscPrcnt}
                    type="number"
                    fullWidth
                    onChange={(e) => {
                      let value = e.target.value;
                      setConceptSelected((concept) => ({ ...concept, DiscPrcnt: value }));
                    }}
                    inputProps={{
                      min: 0,
                      max: 100,
                      step: 0.01,
                    }}
                  />
                </TableCell>
                {/* PriceBefDi */}
                <TableCell>
                  {currency(conceptSelected.Price * (1 - conceptSelected.DiscPrcnt / 100))}
                </TableCell>
                {/* VatGroup */}
                <TableCell>
                  <FormControl fullWidth margin="normal" size="small">
                    <Select
                      fullWidth
                      value={conceptSelected.VatGroup}
                      onChange={(e) => {
                        let value = e.target.value;
                        setConceptSelected((concept) => ({ ...concept, VatGroup: value }));
                      }}
                    >
                      {taxes.map((tax) => {
                        return (
                          <MenuItem key={tax.id} value={tax.Code}>
                            {tax.Name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </TableCell>
                {/* VatPrcnt */}
                <TableCell>
                  {parseFloat(
                    taxes.find((tax) => tax.Code === conceptSelected.VatGroup)?.Rate || 0,
                  ).toFixed(2)}
                  %
                </TableCell>
                {/* PriceAfVAT */}
                <TableCell>
                  {currency(
                    conceptSelected.Price *
                      (1 - conceptSelected.DiscPrcnt / 100) *
                      (1 +
                        parseFloat(
                          taxes.find((tax) => tax.Code === conceptSelected.VatGroup)?.Rate || 0,
                        ) /
                          100),
                  )}
                </TableCell>
                <TableCell align="center">
                  {!process && (
                    <RegularButton
                      justIcon
                      round
                      size="sm"
                      color="success"
                      onClick={addConcept}
                      disabled={
                        processing ||
                        conceptSelected.Price == 0 ||
                        conceptSelected.Dscription.length === 0 ||
                        conceptSelected.AcctCode.length === 0
                      }
                    >
                      <DoneAll />
                    </RegularButton>
                  )}
                </TableCell>
              </TableRow>
            )}

            {concepts.map((concept, i) => {
              return (
                <ConceptRow
                  key={concept.id}
                  taxes={taxes}
                  concept={concept}
                  setConcepts={setConcepts}
                  accounts={accounts}
                  index={i}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {process && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
          <>
            <RegularButton
              color="warning"
              style={{ marginRight: '20px' }}
              onClick={() => updateOrder()}
            >
              <Create /> Editar
            </RegularButton>
            <RegularButton
              color="success"
              onClick={() => {
                confirmChange('Aprobar', true);
              }}
            >
              <DoneAll /> Aprobar
            </RegularButton>
            <RegularButton
              color="danger"
              style={{ marginLeft: '20px' }}
              onClick={() => {
                confirmChange('Anular', false);
              }}
            >
              <Close /> Anular
            </RegularButton>
          </>
        </div>
      )}

      {concepts.length > 0 && !process && (
        <RegularButton
          color="success"
          style={{ marginTop: '15px', float: 'right' }}
          disabled={processing || !dataSale.base_seller_id || !dataSale.base_business_partner_id}
          onClick={() => saveConceptSale(concepts)}
        >
          {processing ? 'Procesando...' : 'Procesar'}
        </RegularButton>
      )}
    </>
  );
}

export default WithApp(NewSaleConceptDetails);
